import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const config = require("../config.json");

export default class Activity extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    isEditMode: false,
    updatedActivity: {
      activityName: "",
      activityName_en: "",
      activityImage: "",
      category: "",
      priority: 0,
      activityType: "",
      points: "",
      id: "",
      amountRepeatable: "",
      description: "",
      climateDescription: "",
      requirementDescription: "",
      inspirationDescription: "",
      synergyDescription: "",
      climateDescription_en: "",
      requirementDescription_en: "",
      inspirationDescription_en: "",
      synergyDescription_en: "",
      recommendationTitle: "",
      recommendationTitle_en: "",
      kgCO2: "",
      weeklySpecial: false,
      active: false,
      choices: [],
      requirements: [],
      amountOfChoices: 0,
      amountOfRequirements: 0,
      kilometerInput: false,
      recommendableActivity: false,
    },
  };

  componentDidMount() {
    const choicesObject = {};
    for (let i = 1; i <= this.props.activity.choices?.length; i++) {
      const currentChoice = this.props.activity.choices[i - 1];

      choicesObject[`answer${i}_en`] = currentChoice.text_en;
      choicesObject[`answer${i}_da`] = currentChoice.text_da;
      choicesObject[`answer${i}points`] = currentChoice.points;
      choicesObject[`answer${i}kgCO2`] = currentChoice.kgCO2;
    }

    const requirementsObject = {};
    for (let i = 1; i <= this.props.activity.requirements?.length; i++) {
      const currentRequirement = this.props.activity.requirements[i - 1];

      requirementsObject[`requirement${i}_en`] = currentRequirement.text_en;
      requirementsObject[`requirement${i}_da`] = currentRequirement.text_da;
    }

    this.setState({
      updatedActivity: {
        ...this.props.activity,
        amountOfChoices: this.props.activity.choices?.length ?? 0,
        amountOfRequirements: this.props.activity.requirements?.length ?? 0,
        kilometerInput: this.props.activity.kilometerInput
          ? this.props.activity.kilometerInput
          : false,
        recommendableActivity: this.props.activity.recommendableActivity
          ? this.props.activity.recommendableActivity
          : false,
        ...choicesObject,
        ...requirementsObject,
      },
    });
  }

  canActivityBeRecommendable = (activity) =>
    parseInt(activity.amountOfChoices ?? activity.choices?.length ?? 0) > 0;

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    const updatedActivity = {
      ...this.state.updatedActivity,
      [name]: value,
    };

    if (
      name === "amountOfChoices" &&
      !this.canActivityBeRecommendable(updatedActivity)
    ) {
      updatedActivity.recommendableActivity = false;
      updatedActivity.recommendationTitle = "";
      updatedActivity.recommendationTitle_en = "";
    }

    if (name === "recommendableActivity" && !value) {
      updatedActivity.recommendationTitle = "";
      updatedActivity.recommendationTitle_en = "";
    }

    this.setState({
      updatedActivity,
    });
  };

  handleActivityEdit = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleEditSave = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateActivity(this.state.updatedActivity);
  };

  handleActivityCopy = (event) => {
    this.setState({ isEditMode: false });
    this.props.handleAddActivity(this.state.updatedActivity, event, true);
  };

  render() {
    return (
      <div className="box notification">
        {this.props.isAdmin && (
          <Fragment>
            <a
              href="/"
              onClick={this.handleActivityEdit}
              className="product-edit-icon"
            >
              <FontAwesomeIcon icon="edit" />
            </a>
            <button
              onClick={(event) =>
                this.props.handleDeleteActivity(
                  this.state.updatedActivity.id,
                  event
                )
              }
              className="delete"
            ></button>
          </Fragment>
        )}
        {this.state.isEditMode ? (
          <div>
            <p>Navn</p>
            <input
              name="activityName"
              className="input is-medium"
              type="text"
              value={this.state.updatedActivity.activityName}
              onChange={this.handleInputChange}
            />
            <p>Navn (engelsk)</p>
            <input
              name="activityName_en"
              className="input is-medium"
              type="text"
              value={this.state.updatedActivity.activityName_en}
              onChange={this.handleInputChange}
            />
            <p>Billede</p>
            <select
              name="activityImage"
              value={this.state.updatedActivity.activityImage}
              onChange={this.handleInputChange}
            >
              <option value=""></option>
              {this.props.activityImages.map((activityImage) => {
                return (
                  <option key={activityImage.Key} value={activityImage.Key}>
                    {activityImage.Key}
                  </option>
                );
              })}
            </select>
            <p>Type</p>
            <input
              name="activityType"
              className="input is-medium"
              type="text"
              value={this.state.updatedActivity.activityType}
              onChange={this.handleInputChange}
            />
            <div className="control">
              Aktiv: {"  "}
              <input
                name="active"
                className="is-medium"
                type="checkbox"
                checked={this.state.updatedActivity.active}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="control">
              Ugens Special: {"  "}
              <input
                name="weeklySpecial"
                className="is-medium"
                type="checkbox"
                checked={this.state.updatedActivity.weeklySpecial}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="control">
              Kilometer vælger: {"  "}
              <input
                name="kilometerInput"
                className="is-medium"
                type="checkbox"
                checked={this.state.updatedActivity.kilometerInput}
                onChange={this.handleInputChange}
              />
            </div>
            Kategori:
            <select
              name="category"
              value={this.state.updatedActivity.category}
              onChange={this.handleInputChange}
            >
              <option value="Ting og sager">Ting og sager</option>
              <option value="El og varme">El og varme</option>
              <option value="Fødevarer">Fødevarer</option>
              <option value="Transport">Transport</option>
              <option value="Engagement">Engagement</option>
              <option value="Mandag">Mandag</option>
              <option value="Tirsdag">Tirsdag</option>
              <option value="Onsdag">Onsdag</option>
              <option value="Torsdag">Torsdag</option>
              <option value="Fredag">Fredag</option>
            </select>
            <div
              style={{ border: "1px solid #dbdbdb", padding: 5 }}
              className="control"
            >
              Point:
              <input
                name="points"
                className="input is-medium"
                type="text"
                value={this.state.updatedActivity.points}
                onChange={this.handleInputChange}
              />
            </div>
            Prioritet
            <div className="control">
              <input
                name="priority"
                className="input is-medium"
                type="number"
                value={this.state.updatedActivity.priority}
                onChange={this.handleInputChange}
              />
            </div>
            Antal svarmuligheder
            <div className="control">
              <input
                name="amountOfChoices"
                className="input is-medium"
                type="number"
                value={this.state.updatedActivity.amountOfChoices}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="control">
              Anbefalingsaktivitet: {"  "}
              <input
                name="recommendableActivity"
                className="is-medium"
                type="checkbox"
                checked={
                  this.canActivityBeRecommendable(this.state.updatedActivity) &&
                  this.state.updatedActivity.recommendableActivity
                }
                disabled={
                  !this.canActivityBeRecommendable(this.state.updatedActivity)
                }
                onChange={this.handleInputChange}
              />
              {!this.canActivityBeRecommendable(this.state.updatedActivity) && (
                <p>Kræver mindst én svarmulighed.</p>
              )}
            </div>
            {this.state.updatedActivity.recommendableActivity && (
              <>
                <p>Titel til anbefalingsmodal</p>
                <input
                  name="recommendationTitle"
                  className="input is-medium"
                  type="text"
                  value={this.state.updatedActivity.recommendationTitle}
                  onChange={this.handleInputChange}
                />
                <p>Titel til anbefalingsmodal (engelsk)</p>
                <input
                  name="recommendationTitle_en"
                  className="input is-medium"
                  type="text"
                  value={this.state.updatedActivity.recommendationTitle_en}
                  onChange={this.handleInputChange}
                />
              </>
            )}
            {Array.from(
              { length: parseInt(this.state.updatedActivity.amountOfChoices) },
              (_, index) => index + 1
            ).map((idx) => {
              return (
                <div key={idx + "answer" + this.state.updatedActivity.id}>
                  <div>
                    Svarmulighed {idx} engelsk
                    <input
                      className="input is-medium"
                      type="text"
                      value={this.state.updatedActivity[`answer${idx}_en`]}
                      onChange={this.handleInputChange}
                      name={`answer${idx}_en`}
                    />
                  </div>

                  <div>
                    Svarmulighed {idx} dansk
                    <input
                      className="input is-medium"
                      type="text"
                      value={this.state.updatedActivity[`answer${idx}_da`]}
                      onChange={this.handleInputChange}
                      name={`answer${idx}_da`}
                    />
                  </div>

                  <div>
                    Point
                    <input
                      className="input is-medium"
                      type="text"
                      value={this.state.updatedActivity[`answer${idx}points`]}
                      onChange={this.handleInputChange}
                      name={`answer${idx}points`}
                    />
                  </div>

                  <div>
                    KG co2
                    <input
                      className="input is-medium"
                      type="text"
                      value={this.state.updatedActivity[`answer${idx}kgCO2`]}
                      onChange={this.handleInputChange}
                      name={`answer${idx}kgCO2`}
                    />
                  </div>
                  <br />
                </div>
              );
            })}
            Antal krav
            <div className="control">
              <input
                name="amountOfRequirements"
                className="input is-medium"
                type="number"
                value={this.state.updatedActivity.amountOfRequirements}
                onChange={this.handleInputChange}
              />
            </div>
            {Array.from(
              {
                length: parseInt(
                  this.state.updatedActivity.amountOfRequirements
                ),
              },
              (_, index) => index + 1
            ).map((idx) => {
              return (
                <div key={idx + "requirement" + this.state.updatedActivity.id}>
                  <div>
                    Krav {idx} engelsk
                    <input
                      className="input is-medium"
                      type="text"
                      value={this.state.updatedActivity[`requirement${idx}_en`]}
                      onChange={this.handleInputChange}
                      name={`requirement${idx}_en`}
                    />
                  </div>

                  <div>
                    Krav {idx} dansk
                    <input
                      className="input is-medium"
                      type="text"
                      value={this.state.updatedActivity[`requirement${idx}_da`]}
                      onChange={this.handleInputChange}
                      name={`requirement${idx}_da`}
                    />
                  </div>
                  <br />
                </div>
              );
            })}
            <p>KG CO2</p>
            <input
              name="kgCO2"
              className="input is-medium"
              type="text"
              value={this.state.updatedActivity.kgCO2}
              onChange={this.handleInputChange}
            />
            <p>Gentagelig</p>
            <input
              name="amountRepeatable"
              className="input is-medium"
              type="text"
              value={this.state.updatedActivity.amountRepeatable}
              onChange={this.handleInputChange}
            />
            Beskrivelse
            <textarea
              className="textarea"
              value={this.state.updatedActivity.description}
              onChange={this.handleInputChange}
            ></textarea>
            Krav
            <textarea
              name="requirementDescription"
              className="textarea"
              value={this.state.updatedActivity.requirementDescription}
              onChange={this.handleInputChange}
            />
            Klima
            <textarea
              name="climateDescription"
              className="textarea"
              value={this.state.updatedActivity.climateDescription}
              onChange={this.handleInputChange}
            />
            Inspiration
            <textarea
              name="inspirationDescription"
              className="textarea"
              value={this.state.updatedActivity.inspirationDescription}
              onChange={this.handleInputChange}
            />
            Synergi
            <textarea
              name="synergyDescription"
              className="textarea"
              value={this.state.updatedActivity.synergyDescription}
              onChange={this.handleInputChange}
            />
            Krav (engelsk)
            <textarea
              name="requirementDescription_en"
              className="textarea"
              value={this.state.updatedActivity.requirementDescription_en}
              onChange={this.handleInputChange}
            />
            Klima (engelsk)
            <textarea
              name="climateDescription_en"
              className="textarea"
              value={this.state.updatedActivity.climateDescription_en}
              onChange={this.handleInputChange}
            />
            Inspiration (engelsk)
            <textarea
              name="inspirationDescription_en"
              className="textarea"
              value={this.state.updatedActivity.inspirationDescription_en}
              onChange={this.handleInputChange}
            />
            Synergi (engelsk)
            <textarea
              name="synergyDescription_en"
              className="textarea"
              value={this.state.updatedActivity.synergyDescription_en}
              onChange={this.handleInputChange}
            />
            <p className="product-id">id: {this.state.updatedActivity.id}</p>
            <button
              type="submit"
              className="button is-info is-small mv-small"
              onClick={this.handleActivityCopy}
            >
              Opret kopi
            </button>
            <button
              type="submit"
              className="button is-info is-small"
              onClick={this.handleEditSave}
            >
              Gem
            </button>
          </div>
        ) : (
          <div>
            <p className="product-title">
              {this.state.updatedActivity.activityName}
            </p>
            <p className="product-id">
              <b>navn engelsk:</b> {this.state.updatedActivity.activityName_en}
            </p>
            {this.state.updatedActivity.activityImage && (
              <img
                className="activity-image"
                src={`${
                  config.s3.activityImagesUrl +
                  this.state.updatedActivity.activityImage
                }`}
              />
            )}
            <p>
              <b>Type:</b> {this.state.updatedActivity.activityType}
            </p>
            <p>
              <b>Kategori:</b> {this.state.updatedActivity.category}
            </p>
            <b>Aktiv: {"  "}</b>
            <input
              type="checkbox"
              checked={this.state.updatedActivity.active}
              readOnly={true}
            />
            <br />
            <b>Ugens special: {"  "}</b>
            <input
              type="checkbox"
              checked={this.state.updatedActivity.weeklySpecial}
              readOnly={true}
            />
            <br />
            <b>Kilometer vælger: {"  "}</b>
            <input
              type="checkbox"
              checked={this.state.updatedActivity.kilometerInput}
              readOnly={true}
            />
            <br />
            <b>Anbefalingsaktivitet: {"  "}</b>
            <input
              type="checkbox"
              checked={this.state.updatedActivity.recommendableActivity ?? false}
              readOnly={true}
            />
            {this.state.updatedActivity.recommendableActivity && (
              <>
                <br />
                <p>
                  <b>Anbefalingsmodal titel:</b>{" "}
                  {this.state.updatedActivity.recommendationTitle}
                </p>
                <p>
                  <b>Anbefalingsmodal titel (engelsk):</b>{" "}
                  {this.state.updatedActivity.recommendationTitle_en}
                </p>
              </>
            )}
            {this.state.updatedActivity.choices?.map((choice, idx) => {
              return (
                <div
                  key={idx + this.props.activity.id}
                  style={{
                    padding: 4,
                    marginBottom: 5,
                    border: "solid 1px black",
                    width: "fit-content",
                  }}
                >
                  <p className="product-id">
                    <b>Svarmulighed {idx + 1} dansk:</b> {choice.text_da}
                  </p>
                  <p className="product-id">
                    <b>Svarmulighed {idx + 1} engelsk:</b> {choice.text_en}
                  </p>
                  <p className="product-id">
                    <b>Point:</b> {choice.points}
                  </p>
                  <p className="product-id">
                    <b>Kg CO2:</b> {choice.kgCO2}
                  </p>
                </div>
              );
            })}
            {this.state.updatedActivity.requirements?.map(
              (requirement, idx) => {
                return (
                  <div
                    key={idx + "req" + this.props.activity.id}
                    style={{
                      padding: 4,
                      marginBottom: 5,
                      border: "solid 1px #4a90e2",
                      width: "fit-content",
                      backgroundColor: "#f0f8ff",
                    }}
                  >
                    <p className="product-id">
                      <b>Krav {idx + 1} dansk:</b> {requirement.text_da}
                    </p>
                    <p className="product-id">
                      <b>Krav {idx + 1} engelsk:</b> {requirement.text_en}
                    </p>
                  </div>
                );
              }
            )}
            <p>
              <b>Point:</b> {this.state.updatedActivity.points}
            </p>
            <p>
              <b>Prioritet:</b> {this.state.updatedActivity.priority}
            </p>
            <p>
              <b>Kg CO2:</b> {this.state.updatedActivity.kgCO2}
            </p>
            <p>
              <b>Gentagelig:</b> {this.state.updatedActivity.amountRepeatable}
            </p>
            <br />
            <p>
              <b>Beskrivelse:</b> {this.state.updatedActivity.description}
            </p>
            <br />
            <p>
              <b>Krav:</b> {this.state.updatedActivity.requirementDescription}
            </p>
            <br />
            <p>
              <b>Klima:</b> {this.state.updatedActivity.climateDescription}
            </p>
            <br />
            <p>
              <b>Inspiration: </b>
              {this.state.updatedActivity.inspirationDescription}
            </p>
            <br />
            <p>
              <b>Synergi:</b> {this.state.updatedActivity.synergyDescription}
            </p>
            <br />
            <p>
              <b>Krav (engelsk): </b>
              {this.state.updatedActivity.requirementDescription_en}
            </p>
            <br />
            <p>
              <b>Klima (engelsk): </b>
              {this.state.updatedActivity.climateDescription_en}
            </p>
            <br />
            <p>
              <b>Inspiration (engelsk): </b>
              {this.state.updatedActivity.inspirationDescription_en}
            </p>
            <br />
            <p>
              <b>Synergi (engelsk): </b>
              {this.state.updatedActivity.synergyDescription_en}
            </p>
            <p className="product-id">
              <b>ID:</b> {this.state.updatedActivity.id}
            </p>
          </div>
        )}
      </div>
    );
  }
}
